import React, { useEffect, useState } from 'react';
import { devicesApi, TabletHeldRecord } from '../services/api';
import { formatDate } from '../utils/dateFormat';

// E2 Z4 (raport uwag Bronka 2026-10-19, S7): lokal zablokowany na tablecie (konflikt wersji albo brak zasięgu)
// nie istnieje dla bota — „Wyślij do CEEB" wystawiłby wersję z serwera. Biuro widzi to przy budynku,
// a serwer i tak odmawia wystawienia (409 TABLET_PENDING) do czasu wysyłki z tabletu.
const STATE_LABEL: Record<TabletHeldRecord['state'], string> = {
  pending: 'czeka na wysłanie',
  failed: 'odrzucony przez serwer',
  conflict: 'konflikt wersji — do wyboru na tablecie',
};

export function TabletHeldBanner({ buildingId }: { buildingId: string }) {
  const [held, setHeld] = useState<TabletHeldRecord[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    // Promise.resolve().then — każdy błąd (także brak modułu w testach widoku budynku) ląduje w .catch, nie w renderze.
    Promise.resolve()
      .then(() => devicesApi.held(buildingId))
      .then((rows) => { if (alive) { setHeld(rows); setError(null); } })
      .catch((e: Error) => { if (alive) setError(e.message); });
    return () => { alive = false; };
  }, [buildingId]);

  if (error) {
    return (
      <div data-testid="tablet-held-error" style={{ fontSize: 'var(--text-caption)', color: 'var(--text-secondary)' }}>
        Nie sprawdzono, czy tablety trzymają niewysłane lokale: {error}
      </div>
    );
  }
  if (held.length === 0) return null;
  return (
    <div
      data-testid="tablet-held-banner"
      role="alert"
      style={{
        border: '1px solid var(--status-rec)', borderRadius: 'var(--radius-md)', padding: 'var(--space-3)',
        background: 'var(--surface-card)', display: 'flex', flexDirection: 'column', gap: 'var(--space-1)',
      }}
    >
      <strong style={{ color: 'var(--status-rec)' }}>Tablet ma niewysłaną wersję lokali tego budynku</strong>
      <span style={{ fontSize: 'var(--text-caption)' }}>
        Wystawienie protokołu w CEEB poczeka, aż tablet je wyśle („Sync” → „Synchronizuj” albo „Rozwiąż”).
      </span>
      <ul style={{ margin: 0, paddingLeft: 'var(--space-4)', fontSize: 'var(--text-caption)' }}>
        {held.map((h) => (
          <li key={`${h.deviceId}-${h.apartmentId || h.apartmentNumber}`}>
            m. {h.apartmentNumber || '?'} — {STATE_LABEL[h.state]}; tablet {h.shortId}
            {h.userEmail ? ` (${h.userEmail})` : ''}
            {h.lastSeenAt ? `, ostatni raport ${formatDate(h.lastSeenAt)}` : ''}
          </li>
        ))}
      </ul>
    </div>
  );
}
